var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white z-index-1 left-0 bottom-0 right-0" },
    [
      _c(
        "div",
        {
          staticClass:
            "m-t-10 m-l-10 m-b-5 m-r-12 f-s-12 flex justify-content-between align-items-center",
          staticStyle: { color: "#999" },
        },
        [
          _c("div", [_vm._v("最近搜索")]),
          _c(
            "div",
            {
              staticClass: "flex align-items-center cursor-pointer",
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                  return _vm.clearSearchHistory.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "d-block",
                staticStyle: { width: "16px", height: "17px" },
                attrs: { src: require("@/assets/images/im/delete@2x.png") },
              }),
              _c("span", { staticClass: "d-block m-l-5" }, [_vm._v("清空")]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "flex", staticStyle: { "flex-wrap": "wrap" } },
        _vm._l(_vm.searchHistory, function (item, index) {
          return index < 20
            ? _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "h-25 p-l-10 m-t-10 o-hidden t-o-ellipsis w-s-nowrap p-r-10 f-s-12 cursor-pointer",
                  staticStyle: {
                    "max-width": "94%",
                    "margin-left": "3%",
                    "margin-right": "3%",
                    "line-height": "25px",
                    color: "#999999",
                    background: "#eaeaea",
                    "border-radius": "13px",
                  },
                  on: {
                    mousedown: function ($event) {
                      return _vm.searchNearestHistory(item)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item) + " ")]
              )
            : _vm._e()
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }